import React, { Fragment, useRef, useEffect, useState } from 'react'
import Picture from '../../components/Picture'
import './IndicatorsGrid.scss'

const IndicatorsGrid = () => {
  const gridRef = useRef(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  const checkScrollPosition = () => {
    if (gridRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = gridRef.current
      setCanScrollLeft(scrollLeft > 0)
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1)
    }
  }

  useEffect(() => {
    const grid = gridRef.current
    if (grid) {
      checkScrollPosition()
      grid.addEventListener('scroll', checkScrollPosition)
      return () => grid.removeEventListener('scroll', checkScrollPosition)
    }
  }, [])

  const indicators = [
    {
      iconSrc: '/images/site/icons/donut.svg',
      title: <Fragment>Curva ABC<br />de Clientes</Fragment>,
      description: 'Classifique os clientes com base no valor faturado e defina prioridades na carteira dos vendedores'
    },
    {
      iconSrc: '/images/site/icons/personplus.svg',
      title: <Fragment>Positivação<br />de Clientes</Fragment>,
      description: 'Identifique quantos clientes fizeram pedidos e sua situação antes da positivação'
    },
    {
      iconSrc: '/images/site/icons/reports.svg',
      title: <Fragment>Relatórios<br />de Vendas</Fragment>,
      description: 'Confira vendas e pedidos concluídos em um período e agrupe a visualização como preferir'
    },
    {
      iconSrc: '/images/site/icons/finance.svg',
      title: <Fragment>Evolução<br />de Vendas</Fragment>,
      description: 'Acompanhe quanto já foi vendido e tenha previsão do resultado do mês'
    },
    {
      iconSrc: '/images/site/icons/personsearch.svg',
      title: <Fragment>Acompanhamento de <br />clientes ativos e inativos</Fragment>,
      description: 'Transforme clientes inativos em oportunidades, evite inativações e mantenha as carteiras saudáveis'
    },
    {
      iconSrc: '/images/site/icons/report.svg',
      title: <Fragment>Ranking de metas<br />e vendedores</Fragment>,
      description: 'Acompanhe as vendas em tempo real e incentive a equipe por meio de rankings estratégicos'
    },
    {
      iconSrc: '/images/site/icons/tree.svg',
      title: <Fragment>Força de vendas integrado<br />ao e-commerce B2B</Fragment>,
      description: <Fragment>Venda online e acompanhe os dados de clientes e pedidos feitos pelo <nobr>e-commerce B2B</nobr></Fragment>
    },
    {
      iconSrc: '/images/site/icons/sheet.svg',
      title: <Fragment>Controle de<br /> produtos e estoque</Fragment>,
      description: 'Confira os produtos mais vendidos por cliente e mantenha o estoque sempre atualizado'
    },
    {
      iconSrc: '/images/site/icons/money.svg',
      title: <Fragment>Comissionamento<br />na palma da mão</Fragment>,
      description: 'Tenha as informações que você precisa sobre comissões a qualquer momento e incentive o time'
    }
  ]

  return (
    <section className="indicators-grid">
      <div className="container">
        <div className="header">
          <h3><p className="over-title">🔥 Todos os seus resultados em um só painel</p>
          <p className="title">
            São mais de 25 indicadores e 30 relatórios
            <br />
            para transformar dados em decisões
          </p></h3>
        </div>
        
        <div className="grid-wrapper">
          <div className="mobile-scroll-indicators">
            <div className={`scroll-arrow left ${canScrollLeft ? 'active' : ''}`}>
              <Picture src="/images/site/arrow.svg" alt="Scroll left" />
            </div>
            <div className={`scroll-arrow right ${canScrollRight ? 'active' : ''}`}>
              <Picture src="/images/site/arrow.svg" alt="Scroll right" />
            </div>
          </div>
          <div className="grid" ref={gridRef}>
            {indicators.map((indicator, index) => (
              <div key={index} className="indicator-card">
                <div className="icon-container">
                  <Picture 
                    src={indicator.iconSrc} 
                    alt={indicator.title}
                    className="icon"
                  />
                </div>
                <p className="card-title">{indicator.title}</p>
                <p className="card-description">{indicator.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default IndicatorsGrid



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/IndicatorsGrid/IndicatorsGrid.jsx